<template>
  <div>
    <Card style="margin-top:0;">
      <div class="grid grid--middle">
        <div class="grid__cell col4-of-12--medium-up">
          <Input
            label="Status"
            type="select"
            :selected="profileData.status"
            :showDefaultOption="false"
            v-on:input-change="handleChange($event, 'updateStatus')"
            :options="[
              {
                name: 'Public',
                value: 'P',
              },
              {
                name: 'Public - show when no results',
                value: 'G',
              },
              {
                name: 'Public - Featured',
                value: 'F',
              },
              {
                name: 'Searchable',
                value: 'S',
              },
              {
                name: 'Hidden',
                value: 'H',
              },
            ]"
          />
        </div>
        <div class="grid__cell col4-of-12--medium-up">
          <Input
            label="Featured"
            type="select"
            :showDefaultOption="false"
            :selected="profileData.featured"
            :disabled="OPP || profileData.status === 'H'"
            v-on:input-change="handleChange($event, 'updateFeatured')"
            :options="[
              {
                name: 'No',
                value: false,
              },
              {
                name: 'Yes',
                value: true,
              },
            ]"
          />
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import Input from '@/components/DesignSystem/Input';
import Card from '@/components/DesignSystem/Card';
export default {
  name: 'StatusContentSection',
  props: {
    OPP: Boolean,
    namespace: String,
    integrationPartner: Boolean,
  },
  components: {
    Input,
    Card,
  },
  computed: {
    profileData() {
      return this.$store.getters[`${this.namespace}/profileData`];
    },
  },
  methods: {
    handleChange({ value }, actionName) {
      this.$store.dispatch(`${this.namespace}/${actionName}`, value);
      this.$store.dispatch(`${this.namespace}/addDirtyTab`, {
        endpoint: '',
        storeKey: 'profile',
      });
    },
  },
};
</script>
